import { defineComponent as _defineComponent } from 'vue'
interface Props {
    title?: string;
    isFiltersFirst?: boolean;
    isFullWidthTitle?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListLayout',
  props: {
    title: null,
    isFiltersFirst: { type: Boolean },
    isFullWidthTitle: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    title?: string;
    isFiltersFirst?: boolean;
    isFullWidthTitle?: boolean;
}




return { __sfc: true,props }
}

})